import { render, staticRenderFns } from "./AddClients.vue?vue&type=template&id=1cf7aea4&scoped=true&"
import script from "./AddClients.vue?vue&type=script&lang=js&"
export * from "./AddClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7aea4",
  null
  
)

export default component.exports